<template>
  <div class="sftp-files-file">
    <font-awesome-icon icon="fa-light fa-file-lines" />
    <div class="d-flex flex-fill" @click="$emit('download')">
      <span>{{ name }}</span>
    </div>
    <div class="sftp-files-file__date">
      <span>
        {{ creationDate }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SFTPFilesFile',
  props: {
    name: {
      type: String,
      default: '',
    },
    creationDate: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.sftp-files-file {
  display: flex;
  padding: 0;
  padding-left: 62px;

  i,
  svg {
    font-size: 28px;
    color: var(--primary-secondary);
    margin-right: 16px;
  }

  &__date {
    width: 200px;
  }
}
</style>
